import React, { useEffect, useState, useRef } from "react";
import { NavLink } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import Logo from "../images/brands/logo-hd.png";
import Years from "../images/brands/years-30.png";
import "./Navbar.css";

const Navbar = ({ onReachOut }) => {
    const [prevScrollY, setPrevScrollY] = useState(0);
    const [isScrollingUp, setIsScrollingUp] = useState(true);
    const navbarRef = useRef(null);
    const togglerRef = useRef(null);

    // Toggle navbar
    const handleTogglerClick = () => {
        const navbar = navbarRef.current;
        const toggler = togglerRef.current;
        if (navbar && toggler) {
            const isOpen = navbar.classList.contains("show");
            navbar.classList.toggle("show", !isOpen);
            toggler.classList.toggle("collapsed", isOpen);
            toggler.setAttribute("aria-expanded", !isOpen);
        }
    };

    // Close navbar
    const closeNavbar = () => {
        const navbar = navbarRef.current;
        const toggler = togglerRef.current;
        if (navbar && toggler && navbar.classList.contains("show")) {
            navbar.classList.remove("show");
            toggler.classList.add("collapsed");
            toggler.setAttribute("aria-expanded", "false");
        }
    };

    // Close on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                navbarRef.current &&
                togglerRef.current &&
                !navbarRef.current.contains(event.target) &&
                !togglerRef.current.contains(event.target) &&
                navbarRef.current.classList.contains("show")
            ) {
                closeNavbar();
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    // Scroll behavior
    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            const isMenuOpen = navbarRef.current?.classList.contains("show");
            setIsScrollingUp(currentScrollY < prevScrollY || isMenuOpen);
            setPrevScrollY(currentScrollY);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [prevScrollY]);

    // Google Translate
    useEffect(() => {
        if (!document.getElementById("google-translate-script")) {
            const script = document.createElement("script");
            script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
            script.async = true;
            script.id = "google-translate-script";
            document.body.appendChild(script);

            window.googleTranslateElementInit = () => {
                new window.google.translate.TranslateElement(
                    { pageLanguage: "en" },
                    "google_translate_element"
                );
            };
        }
    }, []);

    return (
        <nav
            className={`navbar navbar-expand-lg navbar-light bg-white shadow-sm border-bottom sticky-header 
            ${!isScrollingUp ? "hidden" : ""}`}
        >
            <div className="container custom-container">
                <NavLink className="navbar-brand fw-bold" to="/">
                    <img src={Logo} alt="Premier Logo" className="m-0 logo" />
                </NavLink>
                <button
                    className="navbar-toggler border-0"
                    type="button"
                    ref={togglerRef}
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                    onClick={handleTogglerClick}
                >
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav" ref={navbarRef}>
                    <ul className="navbar-nav mx-auto align-items-center">
                        <li className="nav-item fw-bold">
                            <NavLink className="nav-link" exact="true" to="/" activeClassName="active" onClick={closeNavbar}>
                                Home
                            </NavLink>
                        </li>
                        <li className="nav-item fw-bold">
                            <NavLink className="nav-link" to="/products" activeClassName="active" onClick={closeNavbar}>
                                Products
                            </NavLink>
                        </li>
                        <li className="nav-item fw-bold">
                            <HashLink smooth to="/#services" className="nav-link" onClick={closeNavbar}>
                                Services
                            </HashLink>
                        </li>
                        <li className="nav-item fw-bold">
                            <HashLink smooth to="/#quality" className="nav-link" onClick={closeNavbar}>
                                Quality
                            </HashLink>
                        </li>
                        <li className="nav-item fw-bold">
                            <NavLink className="nav-link" to="/sales-partners" activeClassName="active" onClick={closeNavbar}>
                                Sales Partners
                            </NavLink>
                        </li>
                        <li
                            className="nav-item fw-bold"
                            onClick={() => {
                                onReachOut();
                                closeNavbar();
                            }}
                        >
                            <span className="nav-link" style={{ cursor: "pointer" }}>
                                Spares
                            </span>
                        </li>
                        <li className="nav-item fw-bold">
                            <NavLink className="nav-link" to="/careers" activeClassName="active" onClick={closeNavbar}>
                                Careers
                            </NavLink>
                        </li>
                        <li className="nav-item fw-bold">
                            <NavLink className="nav-link" to="/about-us" activeClassName="active" onClick={closeNavbar}>
                                Our Story
                            </NavLink>
                        </li>
                        <li className="nav-item fw-bold">
                            <NavLink className="nav-link" to="/contact-us" activeClassName="active" onClick={closeNavbar}>
                                Contact Us
                            </NavLink>
                        </li>
                    </ul>
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="mx-2">
                            <img src={Years} alt="Premier 30 Years" className="m-0 years-logo" />
                        </div>
                        <div id="google_translate_element" className="mx-2"></div>
                    </div>

                </div>
            </div>
        </nav>
    );
};

export default Navbar;


